import { render, staticRenderFns } from "./TerminalForm.vue?vue&type=template&id=45fe08bf&"
import script from "./TerminalForm.vue?vue&type=script&lang=js&"
export * from "./TerminalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports